import { render, staticRenderFns } from "./ProfessionalEditButton.vue?vue&type=template&id=50611e4a&"
import script from "./ProfessionalEditButton.vue?vue&type=script&lang=js&"
export * from "./ProfessionalEditButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports